import { Injectable } from "@angular/core";

import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, map } from "rxjs/Operators";
import { Observable, throwError } from "rxjs";
import { AppConfig } from "../../app.config";

import { UserService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class HolidayListService {
  constructor(
    private http: HttpClient,
    private config: AppConfig,
    private _userService: UserService
  ) {}

  private handleError(error: HttpErrorResponse) {
    return throwError(error.error);
  }

  GetHolidayDetails(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HolidayListApi/GetHolidayDetails")
      .pipe(catchError(this.handleError));
  }

  SaveHolidayDetails(details: any) {
    return this.http
      .post(this.config.apiUrl + "HolidayListApi/SaveHolidayDetails", details)
      .pipe(catchError(this.handleError));
  }

  GetHolidayListDetails(id: any): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HolidayListApi/GetHolidayListDetails?Id=" + id)
      .pipe(catchError(this.handleError));
  }

  GetWorkShift(): Observable<any> {
    return this.http
      .get(this.config.apiUrl + "HolidayListApi/GetWorkShift")
      .pipe(catchError(this.handleError));
  }

  SaveHolidayDetailsList(details: any) {
    return this.http
      .post(
        this.config.apiUrl + "HolidayListApi/SaveHolidayListDetails",
        details
      )
      .pipe(catchError(this.handleError));
  }

  DeleteHolidayListDetails(details: any) {
    return this.http
      .delete(
        this.config.apiUrl +
          "HolidayListApi/DeleteHolidayListDetails?Id=" +
          details.Id
      )
      .pipe(catchError(this.handleError));
  }

  DeleteHolidayDetails(details: any) {
    return this.http
      .delete(
        this.config.apiUrl +
          "HolidayListApi/DeleteHolidayDetails?Id=" +
          details.Id
      )
      .pipe(catchError(this.handleError));
  }
}
